// src/components/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
        {/* <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        <Link to="/terms" className="footer-link">Terms of Service</Link> */}
      </div>
      <div className="copyright">
        &copy; {new Date().getFullYear()} Yuba. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
